// Detect if app is running in standalone mode
const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

document.addEventListener('DOMContentLoaded', function() {
  const backButton = document.getElementById('pwa-back-button');

  if (!backButton) return;

  if (isStandalone) {
    // Show the back button
    backButton.style.display = 'block';
  }

  // Make the button go back
  backButton.addEventListener('click', function() {
    window.history.back();
  });
});
